import React, { Component } from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'
import { withRouter } from 'react-router'

import { Layout, Container, Footer, PageTitle, Content } from 'src/components/Layout'
import List from 'src/components/List/List'
import { Text } from '@chakra-ui/react'
import Button from 'src/components/Button/Button'
import moment from 'moment'
import Disclaimer from 'src/modals/Disclaimer'
import {
  geoLocationExists,
  truncateSentense,
  getAddressFromLocation,
  isEmpty,
  getKioskWindow,
} from 'src/utils/helpers'
import intlMessages from './translations'

class Claims extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showDisclaimer: false,
      errors: {
        vehicle: null,
      },
    }
  }
  componentDidMount() {
    const { savedDate, showDisclaimer, setDateAndTime, date, time } = this.props

    if (geoLocationExists() && this.dateExpired(savedDate)) {
      this.getWeather()
    }

    if (!date && !time) {
      setDateAndTime({ date: moment().format('L'), time: new Date() })
    }

    // check redux state if disclaimer already have been shown
    if (showDisclaimer) {
      this.setState({
        showDisclaimer: true,
      })
    }
  }

  handleCloseDisclaimer = () => {
    const { setDisclaimer } = this.props

    this.setState(
      {
        showDisclaimer: false,
      },
      () => {
        setDisclaimer(false)
      },
    )
  }

  /**
   * Try to find error from current state.
   *
   * @param claimGroup
   * @return {null|*}
   */
  getItemError = claimGroup => {
    try {
      const { errors } = this.state

      if (isEmpty(errors) || !errors.hasOwnProperty(claimGroup) || isEmpty(errors[claimGroup])) {
        return null
      }

      return errors[claimGroup]
    } catch (e) {
      return null
    }
  }

  getList = props => {
    const { intl, dateTimeDisplay } = this.props

    const damageTypes = {
      'vehicle-collision': 'Vehicle Collision',
      'windshield-damage': 'Windshield Damage',
      'hit-and-run': 'Hit and Run',
      'natural-disaster': 'Natural Disaster',
    }

    return [
      {
        leftIcon: !props.vehicleCompleted ? 'CheckedNo' : 'Checked',
        name: intl.formatMessage(intlMessages.claimsVehicles),
        description: !props.vehicle
          ? intl.formatMessage(intlMessages.claimsIncomplete)
          : props.vehicle.description,
        url: '/claims/vehicles',
        hideArrow: true,
        checked: props.vehicleCompleted,
        errorMessage: this.getItemError('vehicle'),
      },
      {
        leftIcon: 'Checked',
        name: intl.formatMessage(intlMessages.claimsTimeAndDate),
        description: dateTimeDisplay,
        url: '/claims/time-and-date',
        hideArrow: true,
        checked: true,
      },
      {
        leftIcon: !props.locationCompleted ? 'CheckedNo' : 'Checked',
        name: intl.formatMessage(intlMessages.claimsLocation),
        description: !props.claimLocation
          ? intl.formatMessage(intlMessages.claimsIncomplete)
          : getAddressFromLocation(props.claimLocation),
        url: '/claims/location',
        hideArrow: true,
        checked: props.locationCompleted,
      },
      {
        leftIcon: !props.weatherCompleted ? 'CheckedNo' : 'Checked',
        name: intl.formatMessage(intlMessages.claimsWeather),
        url: '/claims/weather',
        description: !props.weatherDescription
          ? intl.formatMessage(intlMessages.claimsIncomplete)
          : props.weatherDescription,
        hideArrow: true,
        checked: props.weatherCompleted,
      },
      {
        leftIcon: !props.driversCompleted ? 'CheckedNo' : 'Checked',
        name: intl.formatMessage(intlMessages.claimsDriver),
        description: !props.driver
          ? props.driversCompleted
            ? intl.formatMessage(intlMessages.claimsNoDriver)
            : intl.formatMessage(intlMessages.claimsIncomplete)
          : !props.driversCompleted
          ? intl.formatMessage(intlMessages.claimsIncomplete)
          : `${props.driver.firstName} ${props.driver.lastName}`,
        url: '/claims/drivers',
        checked: props.driversCompleted,
        hideArrow: true,
      },
      {
        leftIcon: !props.whatHappenedCompleted ? 'CheckedNo' : 'Checked',
        name: intl.formatMessage(intlMessages.claimsWhatHappened),
        description: !props.damageType
          ? intl.formatMessage(intlMessages.claimsIncomplete)
          : damageTypes[props.damageType],
        url: '/claims/what-happened',
        hideArrow: true,
        checked: props.whatHappenedCompleted,
      },
      {
        leftIcon: !props.pictures.length ? 'CheckedNo' : 'Checked',
        name: intl.formatMessage(intlMessages.claimsPictures),
        description: !props.pictures.length
          ? intl.formatMessage(intlMessages.claimsIncomplete)
          : intl.formatMessage(intlMessages.claimsNumberOfPictures, {
              numberOfPictures: props.pictures.length,
            }),
        url: '/claims/pictures',
        checked: props.pictures.length,
        hideArrow: true,
      },
      {
        leftIcon: !props.vehicleAndDriverCompleted ? 'CheckedNo' : 'Checked',
        name: intl.formatMessage(intlMessages.claimsOtherVehicleAndDriver),
        description: isEmpty(props.vehicleAndDriver)
          ? intl.formatMessage(intlMessages.claimsIncomplete)
          : `${props.vehicleAndDriver.make || ''} ${props.vehicleAndDriver.model || ''} ${props
              .vehicleAndDriver.color || ''} ${props.vehicleAndDriver.year || ''}`,
        url: '/claims/other-vehicle-and-driver',
        hideArrow: true,
        checked: props.vehicleAndDriverCompleted,
      },
      {
        leftIcon: !props.officerCompleted ? 'CheckedNo' : 'Checked',
        name: intl.formatMessage(intlMessages.claimsInvestigatingOfficer),
        description: !props.officer
          ? props.officerCompleted
            ? intl.formatMessage(intlMessages.claimsNoOfficer)
            : intl.formatMessage(intlMessages.claimsIncomplete)
          : !props.officerCompleted
          ? intl.formatMessage(intlMessages.claimsIncomplete)
          : `${props.officer.firstName} ${props.officer.lastName}`,
        url: '/claims/investigating-officer',
        hideArrow: true,
        checked: props.officerCompleted,
      },
      {
        leftIcon: !props.passengerCompleted ? 'CheckedNo' : 'Checked',
        name: intl.formatMessage(intlMessages.claimsPassenger),
        description: !props.passenger
          ? props.passengerCompleted
            ? intl.formatMessage(intlMessages.claimsNoPassenger)
            : intl.formatMessage(intlMessages.claimsIncomplete)
          : `${props.passenger.firstName} ${props.passenger.lastName}`,
        url: '/claims/passenger',
        hideArrow: true,
        checked: props.passengerCompleted,
      },
      {
        leftIcon: !props.witnessCompleted ? 'CheckedNo' : 'Checked',
        name: intl.formatMessage(intlMessages.claimsWitness),
        description: !props.witness
          ? props.witnessCompleted
            ? intl.formatMessage(intlMessages.claimsNoWitness)
            : intl.formatMessage(intlMessages.claimsIncomplete)
          : `${props.witness.firstName} ${props.witness.lastName}`,
        url: '/claims/witness',
        hideArrow: true,
        checked: props.witnessCompleted,
      },
      {
        leftIcon: !props.noteCompleted ? 'CheckedNo' : 'Checked',
        name: intl.formatMessage(intlMessages.claimsNotes),
        description:
          !props.noteCompleted || !props.note
            ? intl.formatMessage(intlMessages.claimsIncomplete)
            : truncateSentense(props.note),
        url: '/claims/notes',
        hideArrow: true,
        checked: props.noteCompleted,
      },
    ]
  }

  getWeather = () => {
    navigator.geolocation.getCurrentPosition(position => {
      this.props.getWeather({
        lat: position.coords.latitude,
        lon: position.coords.longitude,
      })
    })
  }

  dateExpired = savedDate => {
    if (!savedDate) {
      return true
    }
    const currentTime = moment()
    return currentTime.diff(savedDate, 'h') > 24
  }

  goToReview = () => {
    const { intl, history, vehicleCompleted } = this.props

    const { errors } = this.state

    const kiosk_window = getKioskWindow()

    // If more things become required, refactor this to go through all items with some new isRequired param
    if (!vehicleCompleted) {
      this.setState({
        errors: {
          ...errors,
          vehicle: intl.formatMessage(intlMessages.claimsVehicleRequired),
        },
      })
      kiosk_window.scrollTo(0, 0)
      return false
    }

    history.push('/claims/review')
  }

  render() {
    const { intl, history, features } = this.props
    const { showDisclaimer } = this.state

    const foundedFeature = features.find(f => f.id == 'reportClaim')
    const title =
      foundedFeature && foundedFeature.title
        ? foundedFeature.title
        : intl.formatMessage(intlMessages.claimsHeader)

    const heading = history.location.pathname.substr(history.location.pathname.lastIndexOf('/') + 1)

    const subtitle =
      heading === 'form' ? intl.formatMessage(intlMessages.claimsFillOutTheForm) : heading

    return (
      <Layout className='m-claims'>
        <Content>
          <PageTitle goBack={() => history.push('/claims')} subtitle={title} title={subtitle} />
          <Container>
            <List
              isColumn={true}
              noMargin={true}
              isColumnReverse={true}
              items={this.getList(this.props)}
            />
            <Footer className='claims-footer global-centered-desktop-content' multi padder>
              <Button
                isFullWidth
                variant='outline'
                px={'40px'}
                py={'10px'}
                onClick={this.props.resetClaims}
              >
                <Text color='text.primary'>
                  <FormattedMessage id='app.claims.reset' defaultMessage='Reset' />
                </Text>
              </Button>
              <Button isFullWidth px={'40px'} py={'10px'} onClick={this.goToReview}>
                <FormattedMessage id='app.claims.preview' defaultMessage='Preview' />
              </Button>
            </Footer>
            <Disclaimer
              visible={showDisclaimer}
              onClose={this.handleCloseDisclaimer}
              onSubmit={this.handleCloseDisclaimer}
              // NOTE: PAT-3546 - For now only **this** Claims disclaimer get the custom message from backend
              // Later on remove this prop and replace it with some kind of "type" prop,
              // so we know which custom message to show (Claims, Add Driver, Remove Driver, Add Vehicle, Get Quote, etc...)
              showCustomMessage={true}
            />
          </Container>
        </Content>
      </Layout>
    )
  }
}

export default withRouter(injectIntl(Claims))
